
<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2023-02-02 17:08:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-06 16:30:07
 * @FilePath: \VUE3\src\pages\caiwu\views\gongzi\gongzibiao\add.vue
-->
<template>
  <div>
    <el-dialog class="w600 h430" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">补发工资</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="教职工" prop="jzgid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.jzgid" clearable filterable >
                <el-option v-for="item in jzgdata" :key="item.id" :label="item.xm" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户名" prop="khxm" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input  class="filter-item" v-model="ruleForm.khxm" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户银行" prop="khyh" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input  class="filter-item" v-model="ruleForm.khyh" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行卡号" prop="yhkh" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input  class="filter-item" v-model="ruleForm.yhkh" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工资类型">
              <el-select v-model="ruleForm.gzlx" disabled clearable filterable >
                <el-option label="正常" :value="0" />
                <el-option label="补发" :value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工资月份" prop="gzny" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.gzny" type="month" value-format="YYYY-MM"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实发金额" prop="sfje" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input  class="filter-item" v-model="ruleForm.sfje" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-for="item in formdata" :key="item.id">
            <el-form-item :label="item.gzxmc" >
              <el-input  class="filter-item" v-model="item.je" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'

const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const jzgdata = ref([]) // 教职工list
loadSelect({
  url: '/api/v2/pdp/jiaozhigong/list',
  data: jzgdata,
  order: 'gh',
  sort: 'asc'
})
const formdata = ref([]) // 工资项
loadSelect({
  url: '/api/v2/caiwu/caiwugongzixiang/list',
  data: formdata,
  order: 'sx',
  sort: 'asc'
})
const getgzjz = (val) => {
  loadSelect(
    {
      url: '/api/v2/caiwu/caiwugongzijizhun/list/' + val.jzgid,
      order: 'gh',
      data: gzjzdata,
      sort: 'asc',
      loadSuccess: function (res) {
        val.khxm = res.data.khxm
        val.khyh = res.data.khyh
        val.sfje = res.data.sfje
        val.yhkh = res.data.yhkh
        val.gzbgzxs.forEach(item => {
          res.data.gzjzxs.forEach(element => {
            if (item.id === element.gzxid) {
              item.je = element.je
            }
          })
        })
      }
    })
}
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      ruleForm.value.gzlx = 1
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  ruleForm.value.gzbgzxs = []

  formdata.value.forEach((item, index) => {
    const obj = {
      gzxid: item.id,
      je: Number(item.je) || 0
    }
    ruleForm.value.gzbgzxs.push(obj)
  })
  submitForm({
    url: '/api/v2/caiwu/jiaozhigonggongzibiao',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
